<template>
  <v-container>
    <v-row justify="start" no-gutters class="my-2">
      <v-btn exact text :to="{ name: 'AnalyticIndex' }">
        <v-icon small left>fa-chevron-left</v-icon>Retour
      </v-btn>
    </v-row>
    <v-row no-gutters class="my-2" v-if="getIsAdmin === true">
      <EventEditorDialog ref="eventDialog"></EventEditorDialog>
    </v-row>
    <v-card>
      <v-card-text>
        <EventCalendar
          :data="data"
          :start.sync="start"
          :end.sync="end"
          :events="getEvents"
          :loading="loadingSalesData"
          @click="clickEvent"
          @update="$store.dispatch('loadSalesEstimates')"
        ></EventCalendar>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
import moment from "moment";
import { EventCalendar, EventEditorDialog } from "../components";
export default {
  name: "EventEditor",
  components: {
    EventCalendar,
    EventEditorDialog
  },
  async beforeRouteEnter(to, from, next) {
    next(async vm => {
      vm.getData();
    });
  },
  async beforeRouteUpdate() {
    this.getData();
  },
  computed: {
    ...mapGetters([
      "getEvents",
      "getOrganisationId",
      "getStoreId",
      "getIsAdmin"
    ])
  },
  data() {
    return {
      loading: false,
      valid: false,
      event: {
        name: "",
        start: moment().format("YYYY-MM-DD"),
        end: null
      },
      data: [],
      start: null,
      end: null,
      firstClick: true,
      loadingSalesData: false
    };
  },
  methods: {
    async getData() {
      this.$store.dispatch("loadEvents");
      this.$store.dispatch("loadSalesEstimates");
    },
    async getSalesData() {
      try {
        this.loadingSalesData = true;
        this.data = await api.getSalesAnalytics({
          store: [this.getStoreId],
          start: moment(this.start)
            .subtract(7, "d")
            .format("YYYY-MM-DD"),
          end: moment(this.end)
            .add(7, "d")
            .format("YYYY-MM-DD")
        });
      } finally {
        this.loadingSalesData = false;
      }
    },
    clickEvent(event) {
      if (this.getIsAdmin === true) {
        this.$refs.eventDialog.open(event.event);
      }
    }
  },
  watch: {
    start() {
      this.getSalesData();
    }
  }
};
</script>

<style></style>
